<template>
  <app-dialog
    v-model="openModel"
    content-class="dialogBonusCondition"
    @onClose="$emit('onClose')"
  >
    <template v-slot:title>
      <h1 class="dialogBonusCondition-title">NEW(希)保険 試算にあたっての留意事項</h1>
    </template>
    <v-card>
      <v-card-text class="dialogBonusCondition-content">
        <p>
          こちらの保険料シミュレーションページは本人のみ試算可能です。
        </p>
        <p>
          本人として加入資格を有する配偶者は､本人としてご加入ください(同一人が本人､配偶者の二つの資格で二重に加入することはできません)｡
        </p>
        <p>
          保険料は概算保険料です。確定保険料は申込締切後に算出し2026年1月1日から適用します。
        </p>
        <p>
          ご加入できる方の範囲は､従業員ご本人､ご本人の配偶者･こどもです｡詳しくはパンフレットをご参照ください｡
        </p>
        <p>
          退職後は新規加入や保険金額の増額はできません。
        </p>
      </v-card-text>
    </v-card>
  </app-dialog>
</template>

<script>
export default {
  name: 'DialogBonusCondition',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    openModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">
.dialogBonusCondition {
  max-width: 720px;
  &-content {
    &.v-card__text {
      padding: 0 30px 20px 44px !important;
    }
  }
  &-title {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #666;
    margin-top: 15px;
    margin-bottom: 5px;
    width: 100%;
  }

  p {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.64;
    letter-spacing: normal;
    text-align: left;
    color: #333;
    display: inline-block;
    margin-bottom: 5px;
    &::before {
      display: inline-block; /* Needed to add space between the bullet and the text */
      width: 10px; /* Also needed for space (tweak if needed) */
      margin-left: -15px; /* Also needed for space (tweak if needed) */
    }
    $numbers: '①', '②', '③', '④', '⑤', '⑥';
    @each $number in $numbers {
      $i: index($numbers, $number);
      &:nth-child(#{$i})::before {
        content: $number;
      }
    }
  }
}
</style>
